export default function IconFertille({
  className,
}: {
  className?: string;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <circle
        cx="9"
        cy="15"
        r="3.25"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <ellipse
        cx="14.6066"
        cy="9.60663"
        rx="2.10647"
        ry="1.57986"
        transform="rotate(-45 14.6066 9.60663)"
        fill="white"
      />
      <path
        d="M16 8.5C17.8639 7.64873 18 4.72727 20 5.31814C22 5.90902 22.3799 3.3921 23 2"
        stroke="white"
        strokeWidth="1.5"
      />
      <circle
        cx="12"
        cy="12"
        r="10.25"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </svg>
  );
}
